import Page from "../Page";
import { useNavigate } from "react-router-dom";
import { Typography, Box, Card, CardContent, Grid } from "@mui/material";
import BugReportIcon from "@mui/icons-material/BugReport";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";

const FeedbackPage = () => {
  const navigate = useNavigate();

  const feedbackOptions = [
    {
      title: "Report a Bug",
      description:
        "Found something broken? Let us know so we can take a gander.",
      icon: BugReportIcon,
      color: "primary.main",
      path: "/feedback/report-a-bug",
    },
    {
      title: "Request a Feature",
      description: "Have an idea? Share your suggestions for improvements.",
      icon: LightbulbIcon,
      color: "orange.main",
      path: "/feedback/request-a-feature",
    },
    {
      title: "Just Say Hi",
      description: "Share your thoughts, comments, or just check in.",
      icon: SentimentSatisfiedAltIcon,
      color: "green.main",
      path: "/feedback/general",
    },
  ];

  return (
    <Page className="feedback-page" pageKey="feedback">
      <Box
        sx={{
          maxWidth: 1000,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography variant="pageTitleWhite" sx={{ display: "block", mb: 2 }}>
            We'd Love Your Feedback
          </Typography>
          <Typography
            variant="p1White"
            sx={{ display: "block", maxWidth: 700, mx: "auto" }}
          >
            Mindstack is continuously evolving. Whether you've found a bug, have
            a feature idea, or just want to share your thoughts, we're here to
            listen.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {feedbackOptions.map((option) => {
            const IconComponent = option.icon;
            return (
              <Grid
                item
                xs={12}
                md={4}
                key={option.path}
                sx={{ mb: { xs: 2, md: 0 } }}
              >
                <Card
                  onClick={() => navigate(option.path)}
                  sx={{
                    height: "100%",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      py: 4,
                      px: 3,
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        width: 100,
                        height: 100,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                        backgroundColor: `${option.color}15`,
                      }}
                    >
                      <IconComponent
                        sx={{ fontSize: 64, color: option.color }}
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{ mb: 1.5, color: "text.primary" }}
                    >
                      {option.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "text.secondary", lineHeight: 1.6 }}
                    >
                      {option.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Page>
  );
};

export default FeedbackPage;
